import useSearchParams from './useSearchParams';
import { IFilterItem, ISelectedItem } from 'components/search/type';
import {
  getCityForCityList,
  getDistrictForCityList,
  getSecInduCodeForCateList,
  getTerInduCodeForCateList,
} from '@component/search/config/filter';

interface IParamsKey {
  [props: string]: string;
}

function getTitle(paramsKey: string, start: string, end: string) {
  switch (paramsKey) {
    case 'money':
      return start !== end ? `${start}~${end}万` : `${start}万`;
    case 'estiblishTime':
      return start !== end ? `${start}~${end}` : `${start}`;
    default:
      return '';
  }
}
const useReverseSelected = () => {
  const {
    setSelectedList,
    cityConfig,
    setCityConfig,
    config,
    selectedOptions,
    setConfig,
    sortTypeConfig,
  } = useSearchParams();
  const list: ISelectedItem[] = [];
  // 对特殊字段特殊处理
  function handleSpecialParams(
    item: IFilterItem,
    optionsArr: string[],
    { paramsKey, paramsStart, paramsEnd }: IParamsKey,
  ) {
    const { filterData, flagStr, filterTitle, isVip = false } = item;
    // 对注册资本特殊处理
    if (optionsArr.includes(paramsStart) && optionsArr.includes(paramsEnd)) {
      const filterItem: IFilterItem = filterData?.find(
        (v) => v.start == selectedOptions[paramsStart] && `${v.end}` == selectedOptions[paramsEnd],
      );
      if (filterItem) {
        list.push({
          filterTitle,
          flagStr,
          paramsKey,
          val: filterItem.val,
          start: filterItem.start,
          end: filterItem.end,
          title: filterItem.title,
          isVip,
        });
      } else {
        list.push({
          filterTitle,
          flagStr,
          paramsKey,
          val: `.${selectedOptions[paramsStart]}.${selectedOptions[paramsEnd]}`,
          start: selectedOptions[paramsStart],
          end: selectedOptions[paramsEnd],
          title: getTitle(paramsKey, selectedOptions[paramsStart], selectedOptions[paramsEnd]),
          isVip,
        });
      }
    }
  }

  function handleItem(selectedVal: string | number, item: IFilterItem) {
    const { filterData, valStr = '', titleStr = '' } = item;

    if (selectedVal && item.paramsKey) {
      filterData?.forEach((k) => {
        if (k.val === selectedVal || k[valStr] === selectedVal) {
          const listItem: ISelectedItem = {
            val: selectedVal,
            filterTitle: item.filterTitle,
            flagStr: item.flagStr,
            title: k.title || k[titleStr],
            paramsKey: item.paramsKey,
            isVip: item.isVip,
          };
          if (k.areaCode) {
            listItem.areaCode = k.areaCode;
          }
          list.push(listItem);
        }
      });
    }
  }

  // 更新所选条件
  const updateSelectedList = () => {
    const optionsArr: string[] = Object.keys(selectedOptions);
    [...cityConfig, ...config].forEach((v: IFilterItem) => {
      if (v.children?.length) {
        v.children.forEach((k: IFilterItem) => {
          if (k.paramsKey === 'staff') {
            handleSpecialParams(k, optionsArr, {
              paramsKey: k.paramsKey,
              paramsStart: `${k.paramsKey}Start`,
              paramsEnd: `${k.paramsKey}End`,
            });
          } else {
            k.paramsKey && handleItem(selectedOptions[k.paramsKey], k);
          }
        });
      } else if (v.paramsKey === 'money' || v.paramsKey === 'estiblishTime') {
        handleSpecialParams(v, optionsArr, {
          paramsKey: v.paramsKey,
          paramsStart: `${v.paramsKey}Start`,
          paramsEnd: `${v.paramsKey}End`,
        });
      } else {
        v.paramsKey && handleItem(selectedOptions[v.paramsKey], v);
      }
    });
    // 排序选项逻辑处理
    if (selectedOptions?.sortType && selectedOptions.sortType !== '0') {
      handleItem(selectedOptions.sortType, sortTypeConfig);
    } else {
      delete selectedOptions.sortType;
    }
    setSelectedList([...list]);
  };

  // 行业
  const updateCateListLevel = () => {
    let cateLevel2: any[];
    let cateLevel3: any[];
    if (selectedOptions.categoryGuobiao2017) {
      cateLevel2 = getSecInduCodeForCateList(selectedOptions.categoryGuobiao2017);
      if (selectedOptions.secInduCode) {
        cateLevel3 = getTerInduCodeForCateList(
          selectedOptions.categoryGuobiao2017,
          selectedOptions.secInduCode,
        );
      }
    }
    const newConfig = config.map((c: IFilterItem) => {
      if (c.paramsKey === 'secInduCode') {
        c.filterData = cateLevel2 || [];
      }
      if (c.paramsKey === 'terInduCode') {
        c.filterData = cateLevel3 || [];
      }
      return c;
    });
    setConfig([...newConfig]);
  };

  // 更新地区配置
  const updateCityListLevel = () => {
    const areaData = cityConfig?.[0]?.filterData || [];

    let cityLevel2: any[];
    let cityLevel3: any[];
    if (selectedOptions.base) {
      cityLevel2 = getCityForCityList(areaData, selectedOptions.base);
      if (cityLevel2.length === 1 || selectedOptions.city) {
        cityLevel3 = getDistrictForCityList(areaData, selectedOptions.base, selectedOptions.city);
      }
    }

    const newCityConfig = cityConfig.map((c: IFilterItem) => {
      if (c.paramsKey === 'city') {
        c.filterData = cityLevel2 || [];
      }
      if (c.paramsKey === 'customAreaCode') {
        c.filterData = cityLevel3 || [];
      }
      return c;
    });

    setCityConfig([...newCityConfig]);
    updateSelectedList();
  };
  return { updateSelectedList, updateCityListLevel, updateCateListLevel };
};
export default useReverseSelected;
